import src from "IMAGE";
export default { src, width: 9, height: 9, blurWidth: 0, blurHeight: 0};
